import { AddIcon, CheckIcon, CloseIcon } from "@chakra-ui/icons";
import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  IconButton,
  Input,
  List,
  ListIcon,
  ListItem,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Stack,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { FormEvent, useEffect, useState } from "react";
import { MdUpdate } from "react-icons/md";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getAddAnswerData } from "redux/slices/addAnswerSlice";
import { getAddQuestionData } from "redux/slices/AddQuestionSlice";

import { apiurl } from "APIURL";
import axios from "axios";
import React from "react";
import {
  selectUpdateFormationData,
  setAnswerToUpdate,
  setQuestionToUpdate,
  setTestQuestions,
  setTestQuestionsAnswers,
} from "redux/slices/updateFormationSlice";
import AddAnswer from "views/admin/formations/add/components/test/AddAnswer";
import UpdateAnswerModal from "./UpdateAnswerModal";
//import { getAddQuestionData, setFiles, setName } from "redux/slices/AddQuestionSlice"

interface AddQuestionProps {
  id: number;
  questionSetter: () => void;
}
const UpdateQuestionModal: React.FC<AddQuestionProps> = ({
  id,
  questionSetter,
}: AddQuestionProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const dispatch = useAppDispatch();
  const [add, setAdd] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const [loadingAnswers, setLoadingAnswers] = useState(false);
  const testQuestions = useAppSelector(selectUpdateFormationData).testQuestions;
  const { content } = useAppSelector(getAddQuestionData);
  const questionAnswers = useAppSelector(
    selectUpdateFormationData
  ).testQuestionsAnswers;
  const answerToAdd = useAppSelector(selectUpdateFormationData).answerToUpdate;
  const answerData = useAppSelector(getAddAnswerData);
  const questionToUpdate = useAppSelector(
    selectUpdateFormationData
  ).questionToUpdate;
  let answerId = Math.floor(Math.random() * 10000);
  const toast = useToast();
  const submitHandler = async (e: React.MouseEvent) => {
    e.preventDefault();
    try {
      const { id, ...rest } = questionToUpdate;
      const questionUpdateResponse = await axios.patch(
        `${apiurl}/question/${id}`,
        {
          ...rest,
        }
      );
      dispatch(
        setTestQuestions([
          ...testQuestions.filter((item) => item.id != id),
          questionUpdateResponse.data,
        ])
      );
      toast({
        title: "Question modifiés avec succés",
        status: "success",
      });
    } catch (err) {
      toast({
        title: "Erreur de modification",
        status: "error",
      });
    }
  };
  const addAnswerSubmitHandler = async (e: FormEvent) => {
    e.preventDefault();

    try {
      const answerAddResponse = await axios.post(`${apiurl}/answer`, {
        addedOn: new Date(),
        content: answerData.content,
        isCorrect: answerData.isCorrect === "1" ? true : false,
        lastModifiedOn: new Date(),
        questionId: questionToUpdate.id,
      });
      dispatch(
        setTestQuestionsAnswers([...questionAnswers, answerAddResponse.data])
      );
      setAdd(false);
      toast({
        title: "Réponse ajouté avec succés",
        status: "success",
      });
    } catch (err) {
      toast({
        title: "Erreur d'ajout",
        status: "error",
      });
      setAdd(false);
    }
  };

  useEffect(() => {
    const setState = async (id: number) => {
      setLoadingAnswers(true)
      const res = await axios.get(`${apiurl}/answer/question/${id}`);
      dispatch(setTestQuestionsAnswers(res.data));
      setLoadingAnswers(false)
    };
    setState(id);
  }, [id]);
  return (
    <>
      <IconButton
        icon={<MdUpdate />}
        onClick={() => {
          questionSetter();

          onOpen();
        }}
        colorScheme={"brandScheme"}
        aria-label={""}
      />

      {questionToUpdate != null ? (
        <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={()=>{
          
      
      onClose()
        }}>
          <ModalOverlay />
          <form action="">
            {loading === true ? (
              <Spinner color="brand.500" />
            ) : (
              <ModalContent>
                <ModalHeader>Modifier un Question</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                  <FormControl id="email">
                    <FormLabel>Contenu</FormLabel>
                    <Input
                      value={questionToUpdate.content}
                      onChange={(e) =>
                        dispatch(
                          setQuestionToUpdate({
                            ...questionToUpdate,
                            content: e.target.value,
                          })
                        )
                      }
                      borderRadius={"full"}
                      type="text"
                    />
                  </FormControl>

                  <FormControl id="email">
                    <FormLabel>Réponses</FormLabel>
                    <IconButton
                      icon={<AddIcon />}
                      aria-label={""}
                      onClick={() => setAdd(true)}
                    />
                    <List spacing={3}>
                      {loadingAnswers===true?<Spinner />:
                        questionAnswers.map((item) => (
                          <HStack justifyContent={"space-between"}>
                            <ListItem>
                              <ListIcon
                                as={
                                  item.isCorrect === true
                                    ? CheckIcon
                                    : CloseIcon
                                }
                                color={item.isCorrect ? "green.300" : "red.400"}
                              />
                              {item.content}
                            </ListItem>
                            <UpdateAnswerModal
                              id={item.id}
                              questionId={item.questionId}
                              answerSetter={function (): void {
                                dispatch(setAnswerToUpdate(item));
                              }}
                            />
                          </HStack>
                        ))}
                    </List>
                    {add && (
                      <AddAnswer
                        addOrUpdate="UPDATE"
                        questionId={id}
                        updateHandler={addAnswerSubmitHandler}
                      />
                    )}
                  </FormControl>
                  <Stack my={5} direction="row" spacing={"auto"}></Stack>
                </ModalBody>

                <ModalFooter>
                  <Button
                    type="button"
                    onClick={(e) => {
                      submitHandler(e);
                      onClose();
                    }}
                    colorScheme="brand"
                    mr={3}
                  >
                    Enregistrer
                  </Button>
                  <Button onClick={onClose}>Annuler</Button>
                </ModalFooter>
              </ModalContent>
            )}
          </form>
        </Modal>
      ) : null}
    </>
  );
};
export default UpdateQuestionModal;
